const config = {
    homePage: {
        meta: {
            en: {
                title: "Sports Betting | Live Betting | Slots | Live Casino | MaksatBahis",
                description: "Enjoy high-odds sports betting with MaksatBahis. Earn cash rewards on every coupon you play. No limits.",
                keywords: "betting, live betting, betting site, live betting sites, betting sites, casino, poker, bingo, horse racing",
            },
            tr: {
                title: "Spor Bahisleri | Canlı Bahisler | Slotlar | Canlı Casino | MaksatBahis",
                description: "MaksatBahis Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. MaksatBahis ile oynadığın her kupona nakit para kazan. Limit yok.",
                keywords: "bahis, canlı bahis, bahis sitesi, canlı bahis siteleri, bahis siteleri, casino, poker, tombala, at yarışı",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Apostas Esportivas | Apostas ao Vivo | Slots | Cassino ao Vivo | MaksatBahis",
                description: "Aproveite as apostas esportivas com altas odds na MaksatBahis. Ganhe dinheiro em cada cupom que jogar. Sem limites.",
                keywords: "apostas, apostas ao vivo, site de apostas, sites de apostas ao vivo, sites de apostas, cassino, poker, bingo, corrida de cavalos",
            },
            es: {
                title: "Apuestas Deportivas | Apuestas en Vivo | Slots | Casino en Vivo | MaksatBahis",
                description: "Disfruta de las apuestas deportivas con altas cuotas en MaksatBahis. Gana dinero en efectivo en cada cupón que juegues. Sin límites.",
                keywords: "apuestas, apuestas en vivo, sitio de apuestas, sitios de apuestas en vivo, sitios de apuestas, casino, poker, bingo, carreras de caballos",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    signUpPage: {
        meta: {
            en: {
                title: "Sports Betting | Live Betting | Slots | Live Casino | MaksatBahis",
                description: "Enjoy high-odds sports betting with MaksatBahis. Earn cash rewards on every coupon you play. No limits.",
                keywords: "betting, live betting, betting site, live betting sites, betting sites, casino, poker, bingo, horse racing",
            },
            tr: {
                title: "Spor Bahisleri | Canlı Bahisler | Slotlar | Canlı Casino | MaksatBahis",
                description: "MaksatBahis Spor Bahisleri ile yüksek oranlı bahis yapmanın keyfini yaşayın. MaksatBahis ile oynadığın her kupona nakit para kazan. Limit yok.",
                keywords: "bahis, canlı bahis, bahis sitesi, canlı bahis siteleri, bahis siteleri, casino, poker, tombala, at yarışı",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Apostas Esportivas | Apostas ao Vivo | Slots | Cassino ao Vivo | MaksatBahis",
                description: "Aproveite as apostas esportivas com altas odds na MaksatBahis. Ganhe dinheiro em cada cupom que jogar. Sem limites.",
                keywords: "apostas, apostas ao vivo, site de apostas, sites de apostas ao vivo, sites de apostas, cassino, poker, bingo, corrida de cavalos",
            },
            es: {
                title: "Apuestas Deportivas | Apuestas en Vivo | Slots | Casino en Vivo | MaksatBahis",
                description: "Disfruta de las apuestas deportivas con altas cuotas en MaksatBahis. Gana dinero en efectivo en cada cupón que juegues. Sin límites.",
                keywords: "apuestas, apuestas en vivo, sitio de apuestas, sitios de apuestas en vivo, sitios de apuestas, casino, poker, bingo, carreras de caballos",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    livePage: {
        meta: {
            en: {
                title: "Live Betting | MaksatBahis",
                description:
                    "Join MaksatBahis, the best betting site with the widest live betting variety, the highest live betting odds, and the most live matches, and win!",
                keywords: "live betting, live betting site, best live betting, most trusted live betting",
            },
            tr: {
                title: "Canlı Bahis | MaksatBahis",
                description:
                    "Canlı bahis alanında en çok canlı bahis çeşiti, en yüksek canlı bahis oranlar ve en çok canlı bahis karşılaşma ile en iyi bahis sitesi olan MaksatBahis'ya gelin, kazanın!",
                keywords: "canlı bahis, canlı bahis sitesi, en iyi canlı bahis, en güvenilir canlı bahis",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Apostas ao Vivo | MaksatBahis",
                description:
                    "Venha para a MaksatBahis, o melhor site de apostas, com a maior variedade de apostas ao vivo, as odds mais altas e o maior número de partidas ao vivo, e ganhe!",
                keywords: "apostas ao vivo, site de apostas ao vivo, melhores apostas ao vivo, apostas ao vivo confiáveis",
            },
            es: {
                title: "Apuestas en Vivo | MaksatBahis",
                description:
                    "Ven a MaksatBahis, el mejor sitio de apuestas, con la mayor variedad de apuestas en vivo, las cuotas más altas y el mayor número de partidos en vivo, ¡y gana!",
                keywords: "apuestas en vivo, sitio de apuestas en vivo, mejores apuestas en vivo, apuestas en vivo confiables",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    sportPage: {
        meta: {
            en: {
                title: "Sports Betting | MaksatBahis",
                description: "Bet on football, basketball, tennis, volleyball, handball, and all other sports with high odds at MaksatBahis!",
                keywords: "sports betting, sports bets, football betting, basketball betting",
            },
            tr: {
                title: "Spor Bahisleri | MaksatBahis",
                description: "Futbol, basketbol, tenis, voleybol ve hentbol gibi tüm spor branları için oynana bahis çeşitleri ve diğer tüm spor bahisleri, yüksek oranlar ile MaksatBahis’te!",
                keywords: "spor bahisleri, spor bahis, futbol bahisleri, basketbol bahisleri",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Apostas Esportivas | MaksatBahis",
                description: "Todos os tipos de apostas para futebol, basquete, tênis, vôlei, handebol e demais esportes, com altas odds, na MaksatBahis!",
                keywords: "apostas esportivas, apostas de esportes, apostas de futebol, apostas de basquete",
            },
            es: {
                title: "Apuestas Deportivas | MaksatBahis",
                description: "Todo tipo de apuestas para fútbol, básquet, tenis, vóley, balonmano y demás deportes, con altas cuotas, ¡en MaksatBahis!",
                keywords: "apuestas deportivas, apuestas de deportes, apuestas de fútbol, apuestas de básquet",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    casinosPage: {
        meta: {
            en: {
                title: "Live Casino | MaksatBahis",
                description: "Play popular casino games like roulette, blackjack, baccarat, and casino hold'em with live streams in the MaksatBahis live casino lobby!",
                keywords: "live casino, live roulette, live blackjack, live baccarat, live turkish roulette, live holdem",
            },
            tr: {
                title: "Canlı Casino | MaksatBahis",
                description: "Rulet, blackjack, baccarat, casino hold’em gibi popüler casino oyunlarını canlı yayın aktarımları ile MaksatBahis’in canlı casino salonunda oynayın!",
                keywords: "canlı casino, canlı rulet, canlı blackjeack, canlı baccarat, canlı türk ruleti, canlı holdem",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Cassino ao Vivo | MaksatBahis",
                description: "Jogue roleta, blackjack, baccarat, casino hold’em e outros jogos populares de cassino com transmissões ao vivo no salão de cassino ao vivo da MaksatBahis!",
                keywords: "cassino ao vivo, roleta ao vivo, blackjack ao vivo, baccarat ao vivo, roleta turca ao vivo, holdem ao vivo",
            },
            es: {
                title: "Casino en Vivo | MaksatBahis",
                description: "¡Juega ruleta, blackjack, baccarat, casino hold’em y otros juegos populares de casino con transmisiones en vivo en la sala de casino en vivo de MaksatBahis!",
                keywords: "casino en vivo, ruleta en vivo, blackjack en vivo, baccarat en vivo, ruleta turca en vivo, holdem en vivo",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    slotsPage: {
        meta: {
            en: {
                title: "Slot Games | MaksatBahis",
                description: "Join MaksatBahis, the best casino site with the widest slot game variety, and win on live casino slots!",
                keywords: "slot, play slots, slot games, live slots",
            },
            tr: {
                title: "Slot Oyunları | MaksatBahis",
                description: "Slot oyunları alanında en çok slot oyun çeşiti ile en iyi casino sitesi olan MaksatBahis'ya gelin, canlı casino'daki slot oyunlarında kazanın!",
                keywords: "slot, slot oyna, slot oyunları, canlı slot",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Jogos de Slot | MaksatBahis",
                description: "Venha para a MaksatBahis, o melhor cassino com a maior variedade de slots, e ganhe nos jogos de slot do cassino ao vivo!",
                keywords: "slot, jogar slots, jogos de slot, slots ao vivo",
            },
            es: {
                title: "Juegos de Slots | MaksatBahis",
                description: "¡Ven a MaksatBahis, el mejor casino con la mayor variedad de slots, y gana en los juegos de slots del casino en vivo!",
                keywords: "slots, jugar slots, juegos de slots, slots en vivo",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    slotsBattlePage: {
        meta: {
            en: {
                title: "Slot Battle",
                description: "Slot Battle, first in Turkey",
                keywords: "",
            },
            tr: {
                title: "Slot Battle",
                description: "Slot Battle Türkiye'de ilk",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Slot Battle",
                description: "Slot Battle, o primeiro na Turquia",
                keywords: "",
            },
            es: {
                title: "Slot Battle",
                description: "Slot Battle, el primero en Turquía",
                keywords: "",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    liveCasinoPage: {
        meta: {
            en: {
                title: "Live Slot",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Canlı Slot",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Slots ao Vivo",
                description: "",
                keywords: "",
            },
            es: {
                title: "Slots en Vivo",
                description: "",
                keywords: "",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    forgotPassword: {
        meta: {
            en: {
                title: "Forgot Password",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Şifremi unuttum",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Esqueci minha senha",
                description: "",
                keywords: "",
            },
            es: {
                title: "Olvidé mi contraseña",
                description: "",
                keywords: "",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    resetPassword: {
        meta: {
            en: {
                title: "Reset Password",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Şifre yenileme",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Redefinir senha",
                description: "",
                keywords: "",
            },
            es: {
                title: "Restablecer contraseña",
                description: "",
                keywords: "",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    changePassword: {
        meta: {
            en: {
                title: "Change Password",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Şifre Değiştir",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Alterar senha",
                description: "",
                keywords: "",
            },
            es: {
                title: "Cambiar contraseña",
                description: "",
                keywords: "",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    promoPage: {
        meta: {
            en: {
                title: "Bonuses | MaksatBahis",
                description: "Win with MaksatBahis, the betting site with the highest bonus rates and the lowest wagering requirements!",
                keywords: "bonus, betting bonuses, casino bonuses, bonus sites",
            },
            tr: {
                title: "Bonuslar | MaksatBahis",
                description: "En yüksek oranlı bonuslar ve en düşük çevrim şartına sahip bonus veren bahis sitesi olan MaksatBahis ile kazanın!",
                keywords: "bonus, bahis bonusları, casno bonusları, bonus veren siteler",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Bônus | MaksatBahis",
                description: "Ganhe com a MaksatBahis, o site de apostas com os bônus de maior porcentagem e os menores requisitos de rollover!",
                keywords: "bônus, bônus de apostas, bônus de cassino, sites com bônus",
            },
            es: {
                title: "Bonos | MaksatBahis",
                description: "¡Gana con MaksatBahis, el sitio de apuestas con los bonos de mayor porcentaje y los menores requisitos de apuesta!",
                keywords: "bonos, bonos de apuestas, bonos de casino, sitios con bonos",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    aboutUsPage: {
        meta: {
            en: {
                title: "About Us",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Hakkımızda",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Sobre nós",
                description: "",
                keywords: "",
            },
            es: {
                title: "Sobre nosotros",
                description: "",
                keywords: "",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    myAccountPage: {
        meta: {
            en: {
                title: "My Account",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Hesabım",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Minha conta",
                description: "",
                keywords: "",
            },
            es: {
                title: "Mi cuenta",
                description: "",
                keywords: "",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    betOnGames: {
        meta: {
            en: {
                title: "BetOnGames Live Casino Games | MaksatBahis",
                description:
                    "Join MaksatBahis, the best casino site with the widest BetOnGames live casino and casino variety, and win on live casino slots!",
                keywords: "slot, play slots, slot games, live slots",
            },
            tr: {
                title: "BetOnGames Canlı Casino Oyunları | MaksatBahis",
                description:
                    "BetOnGames oyunları ile canlı casino ve casino alanında en çok casino oyun çeşiti ile en iyi casino sitesi olan MaksatBahis'ya gelin, canlı casino'daki slot oyunlarında kazanın!",
                keywords: "slot, slot oyna, slot oyunları, canlı slot",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Jogos de Cassino ao Vivo BetOnGames | MaksatBahis",
                description:
                    "Venha para a MaksatBahis, o melhor cassino com a maior variedade de jogos BetOnGames no cassino ao vivo, e ganhe nos slots do cassino ao vivo!",
                keywords: "slot, jogar slots, jogos de slot, slots ao vivo",
            },
            es: {
                title: "Juegos de Casino en Vivo BetOnGames | MaksatBahis",
                description:
                    "¡Ven a MaksatBahis, el mejor casino con la mayor variedad de juegos BetOnGames en el casino en vivo, y gana en los slots del casino en vivo!",
                keywords: "slots, jugar slots, juegos de slots, slots en vivo",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    twain: {
        meta: {
            en: {
                title: "Twain",
                description: "Twain",
                keywords: "Twain",
            },
            tr: {
                title: "Twain",
                description: "Twain",
                keywords: "Twain",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Twain",
                description: "Twain",
                keywords: "Twain",
            },
            es: {
                title: "Twain",
                description: "Twain",
                keywords: "Twain",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    liveGames: {
        meta: {
            en: {
                title: "Bingo | MaksatBahis",
                description: "Join Maksatbahis, the best bingo site with the widest live bingo variety, and win at bingo!",
                keywords: "bingo, live bingo, bingo games, play bingo",
            },
            tr: {
                title: "Tombala | MaksatBahis",
                description: "Canlı tombala alanında en çok tombala oyun çeşiti ile en iyi tombala sitesi olan Maksatbahis'ya gelin, tombala oyunlarında kazanın!",
                keywords: "tombala, canlı tombala, tombala oyunları, tombala oyna",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Bingo | MaksatBahis",
                description: "Venha para a MaksatBahis, o melhor site de bingo com a maior variedade de jogos de bingo ao vivo, e ganhe!",
                keywords: "bingo, bingo ao vivo, jogos de bingo, jogar bingo",
            },
            es: {
                title: "Bingo | MaksatBahis",
                description: "¡Ven a MaksatBahis, el mejor sitio de bingo con la mayor variedad de juegos de bingo en vivo, y gana!",
                keywords: "bingo, bingo en vivo, juegos de bingo, jugar bingo",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    lottery: {
        meta: {
            en: {
                title: "Lottery | MaksatBahis",
                description: "Play lottery",
                keywords: "lottery, play lottery",
            },
            tr: {
                title: "Loto | MaksatBahis",
                description: "Loto oyna",
                keywords: "loto, loto oyna",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Loteria | MaksatBahis",
                description: "Jogue na loteria",
                keywords: "loteria, jogar loteria",
            },
            es: {
                title: "Lotería | MaksatBahis",
                description: "Juega a la lotería",
                keywords: "lotería, jugar lotería",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    tvbet: {
        meta: {
            en: {
                title: "TVBET",
                description: "",
                keywords: "",
            },
            tr: {
                title: "TVBET",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "TVBET",
                description: "",
                keywords: "",
            },
            es: {
                title: "TVBET",
                description: "",
                keywords: "",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    helpPage: {
        meta: {
            en: {
                title: "Contact Us",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Bize Ulaşın",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Fale conosco",
                description: "",
                keywords: "",
            },
            es: {
                title: "Contáctanos",
                description: "",
                keywords: "",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    mailVerify: {
        meta: {
            en: {
                title: "Email Verification",
                description: "",
                keywords: " ",
            },
            tr: {
                title: "E-Posta doğrulama",
                description: " ",
                keywords: " ",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Verificação de e-mail",
                description: "",
                keywords: " ",
            },
            es: {
                title: "Verificación de correo electrónico",
                description: "",
                keywords: " ",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
    lobbyPage: {
        meta: {
            en: {
                title: "Lobby",
                description: "",
                keywords: "",
            },
            tr: {
                title: "Lobby",
                description: "",
                keywords: "",
            },
            // aa: { title: "", description: "", keywords: "" },
            pt: {
                title: "Lobby",
                description: "",
                keywords: "",
            },
            es: {
                title: "Lobby",
                description: "",
                keywords: "",
            },
            // fr: { title: "", description: "", keywords: "" },
            // ko: { title: "", description: "", keywords: "" },
            // ja: { title: "", description: "", keywords: "" },
        },
    },
};

export default config;
